"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var flatbuffers = require("flatbuffers");
var Digest = require("./abfv3-digest_generated");
var v3 = require("./abfv3_generated");
exports.kMinShort = -32768;
exports.kMaxShort = 32767;
exports.kMaxUShort = 65535;
exports.bytesPerPoint3_0 = 6 * 8 + 1;
exports.bytesPerPoint3_1 = 7 * 2 + 1;
var FrameVersion;
(function (FrameVersion) {
    FrameVersion[FrameVersion["V3_0"] = 0] = "V3_0";
    FrameVersion[FrameVersion["V3_1"] = 1] = "V3_1";
})(FrameVersion = exports.FrameVersion || (exports.FrameVersion = {}));
/* Encode a set of tracks into a single abf frame, at whatever chunk size they
 * happen to be given us.
 */
function encodeSingleMuxed(tracks, indexAndLengthOverride, digests, version, oEncodedChannels, extensions) {
    if (digests === void 0) {
        digests = [];
    }
    if (version === void 0) {
        version = FrameVersion.V3_0;
    }
    if (oEncodedChannels === void 0) {
        oEncodedChannels = new Set();
    }
    console.assert(!indexAndLengthOverride || indexAndLengthOverride.length === tracks.length, 'If you supply indexAndLengthOverride, you must supply one for each track');
    console.assert(!extensions || extensions.length === tracks.length, 'If you supply extensions, a (possibly empty) list must be supplied for each track');
    var numTracks = tracks.length; // this is literally just to make tslint stfu.
    var builder = new flatbuffers.flatbuffers.Builder();
    var framePtrs = [];
    var digestPtrs = [];
    var _loop_1 = function (trackIdx) {
        var track = tracks[trackIdx];
        var indexOffset = indexAndLengthOverride ? indexAndLengthOverride[trackIdx].startIndex : 0;
        var trackLength = indexAndLengthOverride ? indexAndLengthOverride[trackIdx].trackLength : track.length;
        var samplesThisFrame = track.length;
        var extensionsPtr = extensions
            ? v3.Ayvri.ABF.TrackFrame.createExtensionsVector(builder, extensions[trackIdx].map(function (extension) {
                return encodeExtensionChannel(extension, builder, 0, samplesThisFrame, samplesThisFrame);
            }))
            : undefined;
        switch (version) {
            case FrameVersion.V3_0:
                var frame3_0 = encodeTrackFrame3_0(track, builder, 0, samplesThisFrame, samplesThisFrame, oEncodedChannels);
                v3.Ayvri.ABF.TrackFrame.startTrackFrame(builder);
                v3.Ayvri.ABF.TrackFrame.addTrackId(builder, trackIdx);
                v3.Ayvri.ABF.TrackFrame.addFrameStartIndex(builder, indexOffset);
                v3.Ayvri.ABF.TrackFrame.addFrameLength(builder, samplesThisFrame);
                v3.Ayvri.ABF.TrackFrame.addTrackLength(builder, trackLength);
                v3.Ayvri.ABF.TrackFrame.addFrame30(builder, frame3_0);
                break;
            case FrameVersion.V3_1:
                var frame3_1 = encodeTrackFrame3_1(track, builder, 0, samplesThisFrame, samplesThisFrame, oEncodedChannels);
                v3.Ayvri.ABF.TrackFrame.startTrackFrame(builder);
                v3.Ayvri.ABF.TrackFrame.addTrackId(builder, trackIdx);
                v3.Ayvri.ABF.TrackFrame.addFrameStartIndex(builder, indexOffset);
                v3.Ayvri.ABF.TrackFrame.addFrameLength(builder, samplesThisFrame);
                v3.Ayvri.ABF.TrackFrame.addTrackLength(builder, trackLength);
                v3.Ayvri.ABF.TrackFrame.addFrame31(builder, frame3_1);
                break;
        }
        if (extensionsPtr) {
            v3.Ayvri.ABF.TrackFrame.addExtensions(builder, extensionsPtr);
        }
        framePtrs.push(v3.Ayvri.ABF.TrackFrame.endTrackFrame(builder));
    };
    for (var trackIdx = 0; trackIdx < numTracks; ++trackIdx) {
        _loop_1(trackIdx);
    }
    for (var _i = 0, digests_1 = digests; _i < digests_1.length; _i++) {
        var d = digests_1[_i];
        d.bytesPerPoint = version === FrameVersion.V3_0 ? exports.bytesPerPoint3_0 : exports.bytesPerPoint3_1;
        digestPtrs.push(encodeTrackDigest(d, builder));
    }
    var tracksPtr = v3.Ayvri.ABF.ABF.createTracksVector(builder, framePtrs);
    var digestPtr = v3.Ayvri.ABF.ABF.createDigestsVector(builder, digestPtrs);
    v3.Ayvri.ABF.ABF.startABF(builder);
    v3.Ayvri.ABF.ABF.addTracks(builder, tracksPtr);
    v3.Ayvri.ABF.ABF.addDigests(builder, digestPtr);
    var root = v3.Ayvri.ABF.ABF.endABF(builder);
    v3.Ayvri.ABF.ABF.finishABFBuffer(builder, root);
    return builder.asUint8Array();
}
exports.encodeSingleMuxed = encodeSingleMuxed;
/* Encode a set of tracks into a muxed output stream, with no more than `samplesPerFrame` samples from each
 * track in each abf chunk.
 *
 * We emit the number of chunks that would result from the largest file, if it was encoded on its own.
 * This means that later chunks might have no frames from some tracks. We use the `trackId` to indicate which
 * frames come from which tracks.
 */
function encodeMuxed(tracks, samplesPerFrame, version, oEncodedChannels, extensions) {
    if (samplesPerFrame === void 0) {
        samplesPerFrame = 1000;
    }
    if (version === void 0) {
        version = FrameVersion.V3_0;
    }
    if (oEncodedChannels === void 0) {
        oEncodedChannels = new Set();
    }
    console.assert(!extensions || extensions.length === tracks.length, 'If you supply extensions, a (possibly empty) list must be supplied for each track');
    var numChunks = tracks.map(function (t) { return Math.ceil(t.length / samplesPerFrame); }).reduce(function (c, v) { return Math.max(c, v); }, 0);
    var buffs = new Array(numChunks);
    var numTracks = tracks.length; // this is literally just to make tslint stfu.
    var digests = new Array(tracks.length);
    var _loop_2 = function (frameIdx) {
        var builder = new flatbuffers.flatbuffers.Builder();
        var framePtrs = [];
        var _loop_3 = function (trackIdx) {
            if (digests[trackIdx] === undefined) {
                digests[trackIdx] = {
                    trackId: trackIdx,
                    frameLength: samplesPerFrame,
                    trackLength: tracks[trackIdx].length,
                    frames: [],
                    bytesPerPoint: version === FrameVersion.V3_0 ? exports.bytesPerPoint3_0 : exports.bytesPerPoint3_1,
                };
            }
            var track = tracks[trackIdx];
            var samplesThisFrame = Math.min(samplesPerFrame, track.length - frameIdx * samplesPerFrame);
            if (samplesThisFrame <= 0) {
                return "continue";
            }
            var start = frameIdx * samplesPerFrame;
            var end = start + samplesThisFrame - 1;
            digests[trackIdx].frames.push({
                timestamp: track[end].time - track[0].time,
                pointCount: samplesThisFrame,
                pointOffset: start,
            });
            var extensionsPtr = extensions
                ? v3.Ayvri.ABF.TrackFrame.createExtensionsVector(builder, extensions[trackIdx].map(function (extension) {
                    return encodeExtensionChannel(extension, builder, frameIdx, samplesThisFrame, samplesPerFrame);
                }))
                : undefined;
            switch (version) {
                case FrameVersion.V3_0:
                    var frame3_0 = encodeTrackFrame3_0(track, builder, frameIdx, samplesThisFrame, samplesPerFrame, oEncodedChannels);
                    v3.Ayvri.ABF.TrackFrame.startTrackFrame(builder);
                    v3.Ayvri.ABF.TrackFrame.addTrackId(builder, trackIdx);
                    v3.Ayvri.ABF.TrackFrame.addFrameStartIndex(builder, frameIdx * samplesPerFrame);
                    v3.Ayvri.ABF.TrackFrame.addFrameLength(builder, samplesThisFrame);
                    v3.Ayvri.ABF.TrackFrame.addTrackLength(builder, track.length);
                    v3.Ayvri.ABF.TrackFrame.addFrame30(builder, frame3_0);
                    break;
                case FrameVersion.V3_1:
                    var frame3_1 = encodeTrackFrame3_1(track, builder, frameIdx, samplesThisFrame, samplesPerFrame, oEncodedChannels);
                    v3.Ayvri.ABF.TrackFrame.startTrackFrame(builder);
                    v3.Ayvri.ABF.TrackFrame.addTrackId(builder, trackIdx);
                    v3.Ayvri.ABF.TrackFrame.addFrameStartIndex(builder, frameIdx * samplesPerFrame);
                    v3.Ayvri.ABF.TrackFrame.addFrameLength(builder, samplesThisFrame);
                    v3.Ayvri.ABF.TrackFrame.addTrackLength(builder, track.length);
                    v3.Ayvri.ABF.TrackFrame.addFrame31(builder, frame3_1);
                    break;
            }
            if (extensionsPtr) {
                v3.Ayvri.ABF.TrackFrame.addExtensions(builder, extensionsPtr);
            }
            framePtrs.push(v3.Ayvri.ABF.TrackFrame.endTrackFrame(builder));
        };
        for (var trackIdx = 0; trackIdx < numTracks; ++trackIdx) {
            _loop_3(trackIdx);
        }
        var tracksPtr = v3.Ayvri.ABF.ABF.createTracksVector(builder, framePtrs);
        v3.Ayvri.ABF.ABF.startABF(builder);
        v3.Ayvri.ABF.ABF.addTracks(builder, tracksPtr);
        var root = v3.Ayvri.ABF.ABF.endABF(builder);
        v3.Ayvri.ABF.ABF.finishABFBuffer(builder, root);
        buffs[frameIdx] = builder.asUint8Array();
    };
    for (var frameIdx = 0; frameIdx < numChunks; ++frameIdx) {
        _loop_2(frameIdx);
    }
    var digestBuffs = new Array(digests.length);
    for (var i = 0; i < digests.length; i++) {
        digestBuffs[i] = encodeRootTrackDigest(digests[i]);
    }
    return { trackFrames: buffs, trackDigests: digestBuffs };
}
exports.encodeMuxed = encodeMuxed;
function encodeRootTrackDigest(digest) {
    var builder = new flatbuffers.flatbuffers.Builder();
    var root = encodeTrackDigest(digest, builder);
    Digest.Ayvri.ABF.TrackDigest.finishTrackDigestBuffer(builder, root);
    return builder.asUint8Array();
}
exports.encodeRootTrackDigest = encodeRootTrackDigest;
function encodeTrackDigest(digest, builder) {
    var timestamps = new Array(digest.frames.length);
    var counts = new Array(digest.frames.length);
    var offsets = new Array(digest.frames.length);
    for (var i = 0; i < digest.frames.length; i++) {
        timestamps[i] = digest.frames[i].timestamp;
        counts[i] = digest.frames[i].pointCount;
        offsets[i] = digest.frames[i].pointOffset;
    }
    var timestampPtr = Digest.Ayvri.ABF.TrackDigest.createTimestampVector(builder, timestamps);
    var countsPtr = Digest.Ayvri.ABF.TrackDigest.createPointCountVector(builder, counts);
    var offsetsPtr = Digest.Ayvri.ABF.TrackDigest.createPointOffsetVector(builder, offsets);
    Digest.Ayvri.ABF.TrackDigest.startTrackDigest(builder);
    Digest.Ayvri.ABF.TrackDigest.addTrackId(builder, digest.trackId);
    Digest.Ayvri.ABF.TrackDigest.addFrameLength(builder, digest.frameLength);
    Digest.Ayvri.ABF.TrackDigest.addTrackLength(builder, digest.trackLength);
    Digest.Ayvri.ABF.TrackDigest.addTimestamp(builder, timestampPtr);
    Digest.Ayvri.ABF.TrackDigest.addPointCount(builder, countsPtr);
    Digest.Ayvri.ABF.TrackDigest.addPointOffset(builder, offsetsPtr);
    Digest.Ayvri.ABF.TrackDigest.addBytesPerPoint(builder, digest.bytesPerPoint);
    return Digest.Ayvri.ABF.TrackDigest.endTrackDigest(builder);
}
exports.encodeTrackDigest = encodeTrackDigest;
function scaleToRange(v, vmin, vmax, tmin, tmax) {
    return ((v - vmin) / (vmax - vmin)) * (tmax - tmin) + tmin;
}
exports.scaleToRange = scaleToRange;
function encodeTrackFrameChannelShort(track, builder, key, frameIndex, numSamplesThisFrame, maxSamplesPerFrame) {
    if (numSamplesThisFrame === 0) {
        var ptr2 = v3.Ayvri.ABF.TrackFrameChannelShort.createDeltasVector(builder, []);
        v3.Ayvri.ABF.TrackFrameChannelShort.startTrackFrameChannelShort(builder);
        v3.Ayvri.ABF.TrackFrameChannelShort.addDeltas(builder, ptr2);
        v3.Ayvri.ABF.TrackFrameChannelShort.addInitial(builder, 0);
        v3.Ayvri.ABF.TrackFrameChannelShort.addDmin(builder, 0);
        v3.Ayvri.ABF.TrackFrameChannelShort.addDmax(builder, 0);
        return v3.Ayvri.ABF.TrackFrameChannelShort.endTrackFrameChannelShort(builder);
    }
    var from = frameIndex * maxSamplesPerFrame;
    var start = track[from][key];
    var castBuff = new Int16Array(1);
    var buff = new Array(numSamplesThisFrame);
    var dmin = Number.MAX_VALUE;
    var dmax = Number.MIN_VALUE;
    for (var i = from + 1; i < from + numSamplesThisFrame; i++) {
        dmin = Math.min(dmin, track[i][key] - track[i - 1][key]);
        dmax = Math.max(dmax, track[i][key] - track[i - 1][key]);
    }
    var current = start;
    for (var i = from; i < from + numSamplesThisFrame; i++) {
        var delta = track[i][key] - current;
        buff[i - from] = Math.round(scaleToRange(delta, dmin, dmax, exports.kMinShort, exports.kMaxShort));
        castBuff[0] = buff[i - from];
        current = current + scaleToRange(castBuff[0], exports.kMinShort, exports.kMaxShort, dmin, dmax);
    }
    var ptr = v3.Ayvri.ABF.TrackFrameChannelShort.createDeltasVector(builder, buff);
    v3.Ayvri.ABF.TrackFrameChannelShort.startTrackFrameChannelShort(builder);
    v3.Ayvri.ABF.TrackFrameChannelShort.addDeltas(builder, ptr);
    v3.Ayvri.ABF.TrackFrameChannelShort.addInitial(builder, start);
    v3.Ayvri.ABF.TrackFrameChannelShort.addDmin(builder, dmin);
    v3.Ayvri.ABF.TrackFrameChannelShort.addDmax(builder, dmax);
    return v3.Ayvri.ABF.TrackFrameChannelShort.endTrackFrameChannelShort(builder);
}
exports.encodeTrackFrameChannelShort = encodeTrackFrameChannelShort;
function decodeTrackFrameChannelShort(channel) {
    var current = channel.initial();
    var result = new Array(channel.deltasLength());
    for (var i = 0; i < channel.deltasArray().length; i++) {
        result[i] = current + scaleToRange(channel.deltasArray()[i], exports.kMinShort, exports.kMaxShort, channel.dmin(), channel.dmax());
        current = result[i];
    }
    return result;
}
exports.decodeTrackFrameChannelShort = decodeTrackFrameChannelShort;
function encodeTrackFrameLongMonotonicDeltaChannel(track, builder, key, frameIndex, numSamplesThisFrame, maxSamplesPerFrame) {
    if (numSamplesThisFrame === 0) {
        var ptr2 = v3.Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel.createDeltasVector(builder, []);
        v3.Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel.startTrackFrameLongMonotonicDeltaChannel(builder);
        v3.Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel.addInitial(builder, 0);
        v3.Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel.addDeltas(builder, ptr2);
        return v3.Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel.endTrackFrameLongMonotonicDeltaChannel(builder);
    }
    var from = frameIndex * maxSamplesPerFrame;
    var buff = new Array(numSamplesThisFrame);
    var current = track[from][key];
    for (var i = from; i < from + numSamplesThisFrame; i++) {
        buff[i - from] = track[i][key] - current;
        current = track[i][key];
    }
    var ptr = v3.Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel.createDeltasVector(builder, buff);
    v3.Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel.startTrackFrameLongMonotonicDeltaChannel(builder);
    v3.Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel.addInitial(builder, track[from][key]);
    v3.Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel.addDeltas(builder, ptr);
    return v3.Ayvri.ABF.TrackFrameLongMonotonicDeltaChannel.endTrackFrameLongMonotonicDeltaChannel(builder);
}
exports.encodeTrackFrameLongMonotonicDeltaChannel = encodeTrackFrameLongMonotonicDeltaChannel;
function decodeTrackFrameLongMonotonicDeltaChannel(channel) {
    var current = channel.initial();
    var result = new Array(channel.deltasLength());
    for (var i = 0; i < channel.deltasArray().length; i++) {
        result[i] = current + channel.deltasArray()[i];
        current = result[i];
    }
    return result;
}
exports.decodeTrackFrameLongMonotonicDeltaChannel = decodeTrackFrameLongMonotonicDeltaChannel;
function encodeTrackFrameMonotonicDeltaChannel(track, builder, key, frameIndex, numSamplesThisFrame, maxSamplesPerFrame, scale) {
    if (scale === void 0) {
        scale = 1.0;
    }
    if (numSamplesThisFrame === 0) {
        var ptr2 = v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.createDeltasVector(builder, []);
        v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.startTrackFrameMonotonicDeltaChannel(builder);
        v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.addInitial(builder, 0);
        v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.addScale(builder, 0);
        v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.addDeltas(builder, ptr2);
        return v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.endTrackFrameMonotonicDeltaChannel(builder);
    }
    var from = frameIndex * maxSamplesPerFrame;
    var buff = new Array(numSamplesThisFrame);
    var current = track[from][key];
    for (var i = from; i < from + numSamplesThisFrame; i++) {
        buff[i - from] = (track[i][key] - current) * scale;
        current = track[i][key];
    }
    var ptr = v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.createDeltasVector(builder, buff);
    v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.startTrackFrameMonotonicDeltaChannel(builder);
    v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.addInitial(builder, track[from][key]);
    v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.addScale(builder, scale);
    v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.addDeltas(builder, ptr);
    return v3.Ayvri.ABF.TrackFrameMonotonicDeltaChannel.endTrackFrameMonotonicDeltaChannel(builder);
}
exports.encodeTrackFrameMonotonicDeltaChannel = encodeTrackFrameMonotonicDeltaChannel;
function decodeTrackFrameMonotonicDeltaChannel(channel) {
    var current = channel.initial();
    var scale = 1 / channel.scale();
    var result = new Array(channel.deltasLength());
    for (var i = 0; i < channel.deltasArray().length; i++) {
        result[i] = current + channel.deltasArray()[i] * scale;
        current = result[i];
    }
    return result;
}
exports.decodeTrackFrameMonotonicDeltaChannel = decodeTrackFrameMonotonicDeltaChannel;
function encodeSparseNumericChannel(extension, builder, frameIndex, numSamplesThisFrame, maxSamplesPerFrame) {
    // The channel is sparse, so has a variable number of samples within this frame boundary
    var from = frameIndex * maxSamplesPerFrame;
    var until = from + numSamplesThisFrame;
    var indexBuff = new Array();
    var valueBuff = new Array();
    for (var _i = 0, extension_1 = extension; _i < extension_1.length; _i++) {
        var sample = extension_1[_i];
        if (sample.index >= from && sample.index < until) {
            indexBuff.push(sample.index);
            valueBuff.push(sample.value);
        }
    }
    var idxPtr = v3.Ayvri.ABF.SparseNumericChannel.createIndexesVector(builder, indexBuff);
    var valPtr = v3.Ayvri.ABF.SparseNumericChannel.createValuesVector(builder, valueBuff);
    v3.Ayvri.ABF.SparseNumericChannel.startSparseNumericChannel(builder);
    v3.Ayvri.ABF.SparseNumericChannel.addIndexes(builder, idxPtr);
    v3.Ayvri.ABF.SparseNumericChannel.addValues(builder, valPtr);
    return v3.Ayvri.ABF.SparseNumericChannel.endSparseNumericChannel(builder);
}
exports.encodeSparseNumericChannel = encodeSparseNumericChannel;
function decodeSparseNumericChannel(channel) {
    var len = channel.indexesLength();
    var sparse = new Array(len);
    for (var i = 0; i < len; ++i) {
        sparse[i] = { index: channel.indexesArray()[i], value: channel.valuesArray()[i] };
    }
    return sparse;
}
exports.decodeSparseNumericChannel = decodeSparseNumericChannel;
function encodeSparseTextChannel(extension, builder, frameIndex, numSamplesThisFrame, maxSamplesPerFrame) {
    // The channel is sparse, so has a variable number of samples within this frame boundary
    var from = frameIndex * maxSamplesPerFrame;
    var until = from + numSamplesThisFrame;
    var indexBuff = new Array();
    var valueBuff = new Array();
    for (var _i = 0, extension_2 = extension; _i < extension_2.length; _i++) {
        var sample = extension_2[_i];
        if (sample.index >= from && sample.index < until) {
            indexBuff.push(sample.index);
            valueBuff.push(builder.createString(sample.value));
        }
    }
    var idxPtr = v3.Ayvri.ABF.SparseTextChannel.createIndexesVector(builder, indexBuff);
    var valPtr = v3.Ayvri.ABF.SparseTextChannel.createValuesVector(builder, valueBuff);
    v3.Ayvri.ABF.SparseTextChannel.startSparseTextChannel(builder);
    v3.Ayvri.ABF.SparseTextChannel.addIndexes(builder, idxPtr);
    v3.Ayvri.ABF.SparseTextChannel.addValues(builder, valPtr);
    return v3.Ayvri.ABF.SparseTextChannel.endSparseTextChannel(builder);
}
exports.encodeSparseTextChannel = encodeSparseTextChannel;
function decodeSparseTextChannel(channel) {
    var len = channel.indexesLength();
    var sparse = new Array(len);
    for (var i = 0; i < len; ++i) {
        sparse[i] = { index: channel.indexesArray()[i], value: channel.values(i) };
    }
    return sparse;
}
exports.decodeSparseTextChannel = decodeSparseTextChannel;
function encodeExtensionChannel(extension, builder, frameIndex, numSamplesThisFrame, maxSamplesPerFrame) {
    var namePtr = builder.createString(extension.name);
    switch (extension.encoding) {
        case 'DenseNumeric': {
            var start = frameIndex * maxSamplesPerFrame;
            var end = start + numSamplesThisFrame;
            var buff = extension.samples.slice(start, end);
            var denseNumericPtr = v3.Ayvri.ABF.ExtensionChannel.createDenseNumericVector(builder, buff);
            v3.Ayvri.ABF.ExtensionChannel.startExtensionChannel(builder);
            v3.Ayvri.ABF.ExtensionChannel.addName(builder, namePtr);
            v3.Ayvri.ABF.ExtensionChannel.addDenseNumeric(builder, denseNumericPtr);
            break;
        }
        case 'DenseText': {
            var start = frameIndex * maxSamplesPerFrame;
            var end = start + numSamplesThisFrame;
            var buff = new Array(numSamplesThisFrame);
            for (var i = start; i < end; ++i) {
                buff[i - start] = builder.createString(extension.samples[i]);
            }
            var denseTextPtr = v3.Ayvri.ABF.ExtensionChannel.createDenseTextVector(builder, buff);
            v3.Ayvri.ABF.ExtensionChannel.startExtensionChannel(builder);
            v3.Ayvri.ABF.ExtensionChannel.addName(builder, namePtr);
            v3.Ayvri.ABF.ExtensionChannel.addDenseText(builder, denseTextPtr);
            break;
        }
        case 'SparseNumeric': {
            var sparseNumericPtr = encodeSparseNumericChannel(extension.samples, builder, frameIndex, numSamplesThisFrame, maxSamplesPerFrame);
            v3.Ayvri.ABF.ExtensionChannel.startExtensionChannel(builder);
            v3.Ayvri.ABF.ExtensionChannel.addName(builder, namePtr);
            v3.Ayvri.ABF.ExtensionChannel.addSparseNumeric(builder, sparseNumericPtr);
            break;
        }
        case 'SparseText': {
            var sparseTextPtr = encodeSparseTextChannel(extension.samples, builder, frameIndex, numSamplesThisFrame, maxSamplesPerFrame);
            v3.Ayvri.ABF.ExtensionChannel.startExtensionChannel(builder);
            v3.Ayvri.ABF.ExtensionChannel.addName(builder, namePtr);
            v3.Ayvri.ABF.ExtensionChannel.addSparseText(builder, sparseTextPtr);
            break;
        }
    }
    return v3.Ayvri.ABF.ExtensionChannel.endExtensionChannel(builder);
}
exports.encodeExtensionChannel = encodeExtensionChannel;
function decodeExtensionChannel(channel) {
    if (channel.denseNumericLength() > 0) {
        var samples = new Array(channel.denseNumericLength());
        for (var i = 0; i < channel.denseNumericLength(); ++i) {
            samples[i] = channel.denseNumeric(i);
        }
        return {
            encoding: 'DenseNumeric',
            samples: samples,
            name: channel.name(),
        };
    }
    if (channel.denseTextLength() > 0) {
        var samples = new Array(channel.denseTextLength());
        for (var i = 0; i < channel.denseTextLength(); ++i) {
            samples[i] = channel.denseText(i);
        }
        return {
            encoding: 'DenseText',
            samples: samples,
            name: channel.name(),
        };
    }
    if (channel.sparseNumeric()) {
        return {
            encoding: 'SparseNumeric',
            samples: decodeSparseNumericChannel(channel.sparseNumeric()),
            name: channel.name(),
        };
    }
    if (channel.sparseText()) {
        return {
            encoding: 'SparseText',
            samples: decodeSparseTextChannel(channel.sparseText()),
            name: channel.name(),
        };
    }
    return undefined;
}
function encodeTrackFrame3_1(track, builder, frameIndex, numSamplesThisFrame, maxSamplesPerFrame, oEncodedChannels) {
    if (oEncodedChannels === void 0) {
        oEncodedChannels = new Set();
    }
    var latPtr = encodeTrackFrameChannelShort(track, builder, 'latitude', frameIndex, numSamplesThisFrame, maxSamplesPerFrame);
    var lonPtr = encodeTrackFrameChannelShort(track, builder, 'longitude', frameIndex, numSamplesThisFrame, maxSamplesPerFrame);
    var heightPtr = encodeTrackFrameChannelShort(track, builder, 'height', frameIndex, numSamplesThisFrame, maxSamplesPerFrame);
    var timePtr = encodeTrackFrameLongMonotonicDeltaChannel(track, builder, 'time', frameIndex, numSamplesThisFrame, maxSamplesPerFrame);
    var terrainPtr = encodeTrackFrameChannelShort(track, builder, 'terrain', frameIndex, numSamplesThisFrame, maxSamplesPerFrame);
    var oHeightPtr = encodeTrackFrameChannelShort(track, builder, 'originalHeight', frameIndex, numSamplesThisFrame, maxSamplesPerFrame);
    var exemplar = track[frameIndex * maxSamplesPerFrame] || {};
    var depth = optionalChannel(exemplar.depth, numSamplesThisFrame);
    for (var framePointIdx = 0; framePointIdx < numSamplesThisFrame && depth; ++framePointIdx) {
        var trackPointIdx = frameIndex * maxSamplesPerFrame + framePointIdx;
        depth[framePointIdx] = track[trackPointIdx].depth;
    }
    var depthPtr = depth ? v3.Ayvri.ABF.TrackFrame3_1.createDepthVector(builder, depth) : undefined;
    // I'm ignoring the other channels for now. We don't have any
    // UX for them at the moment anyway.
    v3.Ayvri.ABF.TrackFrame3_1.startTrackFrame3_1(builder);
    v3.Ayvri.ABF.TrackFrame3_1.addLatitude(builder, latPtr);
    oEncodedChannels.add('latitude');
    v3.Ayvri.ABF.TrackFrame3_1.addLongitude(builder, lonPtr);
    oEncodedChannels.add('longitude');
    v3.Ayvri.ABF.TrackFrame3_1.addHeight(builder, heightPtr);
    oEncodedChannels.add('height');
    v3.Ayvri.ABF.TrackFrame3_1.addTime(builder, timePtr);
    oEncodedChannels.add('time');
    v3.Ayvri.ABF.TrackFrame3_1.addTerrain(builder, terrainPtr);
    oEncodedChannels.add('terrain');
    v3.Ayvri.ABF.TrackFrame3_1.addOriginalHeight(builder, oHeightPtr);
    oEncodedChannels.add('originalHeight');
    if (depthPtr !== undefined) {
        v3.Ayvri.ABF.TrackFrame3_1.addDepth(builder, depthPtr);
        oEncodedChannels.add('depth');
    }
    return v3.Ayvri.ABF.TrackFrame3_1.endTrackFrame3_1(builder);
}
function encodeTrackFrame3_0(track, builder, frameIndex, numSamplesThisFrame, maxSamplesPerFrame, oEncodedChannels) {
    if (oEncodedChannels === void 0) {
        oEncodedChannels = new Set();
    }
    var latitude = new Array(numSamplesThisFrame);
    var longitude = new Array(numSamplesThisFrame);
    var height = new Array(numSamplesThisFrame);
    var time = new Array(numSamplesThisFrame);
    // optional channel
    var exemplar = track[frameIndex * maxSamplesPerFrame] || {};
    var terrain = optionalChannel(exemplar.terrain, numSamplesThisFrame);
    var originalHeight = optionalChannel(exemplar.originalHeight, numSamplesThisFrame);
    var depth = optionalChannel(exemplar.depth, numSamplesThisFrame);
    var speed = optionalChannel(exemplar.speed, numSamplesThisFrame);
    var distance = optionalChannel(exemplar.distance, numSamplesThisFrame);
    var heartrate = optionalChannel(exemplar.heartrate, numSamplesThisFrame);
    var cadence = optionalChannel(exemplar.cadence, numSamplesThisFrame);
    var temperature = optionalChannel(exemplar.temperature, numSamplesThisFrame);
    for (var framePointIdx = 0; framePointIdx < numSamplesThisFrame; ++framePointIdx) {
        var trackPointIdx = frameIndex * maxSamplesPerFrame + framePointIdx;
        latitude[framePointIdx] = track[trackPointIdx].latitude;
        longitude[framePointIdx] = track[trackPointIdx].longitude;
        height[framePointIdx] = track[trackPointIdx].height;
        time[framePointIdx] = track[trackPointIdx].time;
        if (terrain) {
            terrain[framePointIdx] = track[trackPointIdx].terrain;
        }
        if (originalHeight) {
            originalHeight[framePointIdx] = track[trackPointIdx].originalHeight;
        }
        if (depth) {
            depth[framePointIdx] = track[trackPointIdx].depth;
        }
        if (speed) {
            speed[framePointIdx] = track[trackPointIdx].speed;
        }
        if (distance) {
            distance[framePointIdx] = track[trackPointIdx].distance;
        }
        if (heartrate) {
            heartrate[framePointIdx] = track[trackPointIdx].heartrate;
        }
        if (cadence) {
            cadence[framePointIdx] = track[trackPointIdx].cadence;
        }
        if (temperature) {
            temperature[framePointIdx] = track[trackPointIdx].temperature;
        }
    }
    // Pack the frame's channels
    var latitudePtr = v3.Ayvri.ABF.TrackFrame3_0.createLatitudeVector(builder, latitude);
    var longitudePtr = v3.Ayvri.ABF.TrackFrame3_0.createLongitudeVector(builder, longitude);
    var heightPtr = v3.Ayvri.ABF.TrackFrame3_0.createHeightVector(builder, height);
    var timePtr = v3.Ayvri.ABF.TrackFrame3_0.createTimeVector(builder, time);
    // Pack the optional attributes
    var terrainPtr = terrain ? v3.Ayvri.ABF.TrackFrame3_0.createTerrainVector(builder, terrain) : undefined;
    var oHeightPtr = originalHeight
        ? v3.Ayvri.ABF.TrackFrame3_0.createOriginalHeightVector(builder, originalHeight)
        : undefined;
    var depthPtr = depth ? v3.Ayvri.ABF.TrackFrame3_0.createDepthVector(builder, depth) : undefined;
    var speedPtr = speed ? v3.Ayvri.ABF.TrackFrame3_0.createSpeedVector(builder, speed) : undefined;
    var distancePtr = distance ? v3.Ayvri.ABF.TrackFrame3_0.createDistanceVector(builder, distance) : undefined;
    var heartratePtr = heartrate ? v3.Ayvri.ABF.TrackFrame3_0.createHeartrateVector(builder, heartrate) : undefined;
    var cadencePtr = cadence ? v3.Ayvri.ABF.TrackFrame3_0.createCadenceVector(builder, cadence) : undefined;
    var temperaturePtr = temperature
        ? v3.Ayvri.ABF.TrackFrame3_0.createTemperatureVector(builder, temperature)
        : undefined;
    // The trackframe version 3.0
    v3.Ayvri.ABF.TrackFrame3_0.startTrackFrame3_0(builder);
    v3.Ayvri.ABF.TrackFrame3_0.addLatitude(builder, latitudePtr);
    oEncodedChannels.add('latitude');
    v3.Ayvri.ABF.TrackFrame3_0.addLongitude(builder, longitudePtr);
    oEncodedChannels.add('longitude');
    v3.Ayvri.ABF.TrackFrame3_0.addHeight(builder, heightPtr);
    oEncodedChannels.add('height');
    v3.Ayvri.ABF.TrackFrame3_0.addTime(builder, timePtr);
    oEncodedChannels.add('time');
    if (terrainPtr !== undefined) {
        v3.Ayvri.ABF.TrackFrame3_0.addTerrain(builder, terrainPtr);
        oEncodedChannels.add('terrain');
    }
    if (oHeightPtr !== undefined) {
        v3.Ayvri.ABF.TrackFrame3_0.addOriginalHeight(builder, oHeightPtr);
        oEncodedChannels.add('originalHeight');
    }
    if (depthPtr !== undefined) {
        v3.Ayvri.ABF.TrackFrame3_0.addDepth(builder, depthPtr);
        oEncodedChannels.add('depth');
    }
    if (speedPtr !== undefined) {
        v3.Ayvri.ABF.TrackFrame3_0.addSpeed(builder, speedPtr);
        oEncodedChannels.add('speed');
    }
    if (distancePtr !== undefined) {
        v3.Ayvri.ABF.TrackFrame3_0.addDistance(builder, distancePtr);
        oEncodedChannels.add('distance');
    }
    if (heartratePtr !== undefined) {
        v3.Ayvri.ABF.TrackFrame3_0.addHeartrate(builder, heartratePtr);
        oEncodedChannels.add('heartrate');
    }
    if (cadencePtr !== undefined) {
        v3.Ayvri.ABF.TrackFrame3_0.addCadence(builder, cadencePtr);
        oEncodedChannels.add('cadence');
    }
    if (temperaturePtr !== undefined) {
        v3.Ayvri.ABF.TrackFrame3_0.addTemperature(builder, temperaturePtr);
        oEncodedChannels.add('temperature');
    }
    return v3.Ayvri.ABF.TrackFrame3_0.endTrackFrame3_0(builder);
}
/* Encode a single track into a set of abf chunks. Each made up of a single frame
 * no larger than `pointsPerFrame`.
 */
function encode(track, pointsPerFrame, version, oEncodedChannels, extensions) {
    if (pointsPerFrame === void 0) {
        pointsPerFrame = 1000;
    }
    if (version === void 0) {
        version = FrameVersion.V3_0;
    }
    if (oEncodedChannels === void 0) {
        oEncodedChannels = new Set();
    }
    return encodeMuxed([track], pointsPerFrame, version, oEncodedChannels, extensions ? [extensions] : undefined);
}
exports.encode = encode;
/* Decode a buffer into a set of TrackFrames. The resulting frames may
 * be part of a single, or multiple tracks. If there are multiple frames
 * from a single track, they are not aggregated.
 */
function decode(buffer) {
    var bytebuffer = new flatbuffers.flatbuffers.ByteBuffer(new Uint8Array(buffer));
    var tracks = v3.Ayvri.ABF.ABF.getRootAsABF(bytebuffer);
    var frames = [];
    for (var i = 0; i < tracks.tracksLength(); ++i) {
        var track = tracks.tracks(i);
        var frame = {
            trackId: track.trackId(),
            firstIndex: track.frameStartIndex(),
            frameLength: track.frameLength(),
            trackLength: track.trackLength(),
            frame: [],
            extensions: [],
        };
        // If we receive a Frame3_0 (version 3.0) representation, we decode that
        var frame3_0 = track.frame30();
        var frame3_1 = track.frame31();
        if (frame3_0) {
            frame.frame = decodeFrame3_0(frame3_0);
        }
        else if (frame3_1) {
            frame.frame = decodeFrame3_1(frame3_1);
        }
        for (var j = 0; j < track.extensionsLength(); ++j) {
            frame.extensions.push(decodeExtensionChannel(track.extensions(j)));
        }
        frames.push(frame);
    }
    var digests = [];
    for (var i = 0; i < tracks.digestsLength(); ++i) {
        var d = tracks.digests(i);
        var digest = {
            trackId: d.trackId(),
            frameLength: d.frameLength(),
            trackLength: d.trackLength(),
            frames: [],
            bytesPerPoint: d.bytesPerPoint(),
        };
        for (var j = 0; j < d.pointCountLength(); ++j) {
            digest.frames.push({
                timestamp: d.timestampArray()[j],
                pointCount: d.pointCountArray()[j],
                pointOffset: d.pointOffsetArray()[j],
            });
        }
        digests.push(digest);
    }
    return { frames: frames, digests: digests };
}
exports.decode = decode;
function decodeTrackDigest(buffer) {
    var bytebuffer = new flatbuffers.flatbuffers.ByteBuffer(new Uint8Array(buffer));
    var decoded = Digest.Ayvri.ABF.TrackDigest.getRootAsTrackDigest(bytebuffer);
    var digest = {
        trackId: decoded.trackId(),
        frameLength: decoded.frameLength(),
        trackLength: decoded.trackLength(),
        frames: [],
        bytesPerPoint: decoded.bytesPerPoint(),
    };
    for (var i = 0; i < decoded.pointCountLength(); i++) {
        digest.frames.push({
            timestamp: decoded.timestampArray()[i],
            pointCount: decoded.pointCountArray()[i],
            pointOffset: decoded.pointOffsetArray()[i],
        });
    }
    return digest;
}
exports.decodeTrackDigest = decodeTrackDigest;
function decodeFrame3_1(frame31) {
    var latitude = decodeTrackFrameChannelShort(frame31.latitude());
    var longitude = decodeTrackFrameChannelShort(frame31.longitude());
    var height = decodeTrackFrameChannelShort(frame31.height());
    var time = decodeTrackFrameLongMonotonicDeltaChannel(frame31.time());
    var terrain = decodeTrackFrameChannelShort(frame31.terrain());
    var originalHeight = decodeTrackFrameChannelShort(frame31.originalHeight());
    var depth = frame31.depthArray() || new Uint8Array(0);
    var frame = new Array(latitude.length);
    for (var i = 0; i < latitude.length; ++i) {
        var point = {
            latitude: latitude[i],
            longitude: longitude[i],
            height: height[i],
            time: time[i],
            terrain: terrain[i],
            originalHeight: originalHeight[i],
            depth: depth[i],
        };
        frame[i] = point;
    }
    return frame;
}
/* Decode the TrackFrame3_0 encoding of a track frame.
 * TODO: We should discuss if this is even necessary. The SOA represetation
 * is similar (or the same), as what `ayvri-viewer/src/Track.js` uses. So
 * for the 3.0 encoding at least we can probably avoid the extra copies.
 * I've done this to be more or less consistent with how we used abf2.
 * BM 08/10/18.
 */
function decodeFrame3_0(frame30) {
    // I'm assuming  all of these are the same length
    var latitude = frame30.latitudeArray();
    var longitude = frame30.longitudeArray();
    var height = frame30.heightArray();
    var time = frame30.timeArray();
    // Optional attributes
    var terrain = frame30.terrainArray() || new Float64Array(0);
    var originalHeight = frame30.originalHeightArray() || new Float64Array(0);
    var depth = frame30.depthArray() || new Uint8Array(0);
    var speed = frame30.speedArray();
    var distance = frame30.distanceArray();
    var heartrate = frame30.heartrateArray();
    var cadence = frame30.cadenceArray();
    var temperature = frame30.temperatureArray();
    var frame = new Array(latitude.length);
    for (var i = 0; i < latitude.length; ++i) {
        var point = {
            latitude: latitude[i],
            longitude: longitude[i],
            height: height[i],
            time: time[i],
            // Note that the common optional attributes are
            // set to undefined if they are not included in the frame.
            // I assume that won't break anything.
            terrain: terrain[i],
            originalHeight: originalHeight[i],
            depth: depth[i],
        };
        frame[i] = point;
    }
    // It is very uncommon that these channels are filled,
    // so we try to avoid unnecessary assignments to undefined
    // and branching in the main loop. That's the idea anyway,
    // I don't pretend know anything about js perf.
    for (var i = 0; speed && i < speed.length; ++i) {
        frame[i].speed = speed[i];
    }
    for (var i = 0; distance && i < distance.length; ++i) {
        frame[i].distance = distance[i];
    }
    for (var i = 0; heartrate && i < heartrate.length; ++i) {
        frame[i].heartrate = heartrate[i];
    }
    for (var i = 0; cadence && i < cadence.length; ++i) {
        frame[i].cadence = cadence[i];
    }
    for (var i = 0; temperature && i < temperature.length; ++i) {
        frame[i].temperature = temperature[i];
    }
    return frame;
}
function optionalChannel(exemplar, size) {
    return exemplar !== undefined && exemplar !== null ? new Array(size) : undefined;
}
